import { mobileShopInst } from './instance';

export interface CreateOrderParams {
  payType: string;
  packageCode: string;
  areaCode: string;
  mobile: string;
  packageName: string;
}

export function createOrder(params: CreateOrderParams) {
  return mobileShopInst.post('/api/v1/create/order', params);
}

export interface CaptureOrderParams {
  payType: string;
  orderId: string;
}

export function captureOrder(params: CaptureOrderParams) {
  return mobileShopInst.post('/api/v1/payment/order', params);
}
